export default "__VITE_ASSET__0af11c25__"